import React from "react";
import FullCalendar from "@fullcalendar/react";
import ruLocale from "@fullcalendar/core/locales/ru";
import timeGridPlugin from "@fullcalendar/timegrid";
import dayGridPlugin from "@fullcalendar/daygrid";
import listPlugin from "@fullcalendar/list";
import interactionPlugin from "@fullcalendar/interaction";
import styles from "./index.module.css";
import {CalendarEvent, PatientEventFull} from "../workTablePatients/EditorTabs/CureProgramTab";
import agent, {PaginateOptions} from "../../agent";
import {EventRepeater} from "../../helpers/CalendarEventsRepeater";
import {Dropdown, DropdownItemProps, DropdownProps, Form, Header} from "semantic-ui-react";
import {DoctorPaginationResponse} from "../workTableDoctors/DoctorsList";
import {DeptPaginationResponse} from "../workTableDepts/DeptList";
import {Dept, Doctor} from "../dashboard";
import {DoctorTitleCase, GeneralTitleCase, getDoctorId, getDoctorTitle, getGeneralTitle} from "../../utils/common";
import {EventClickArg} from "@fullcalendar/core";
import MediaQuery from "react-responsive";
import {firstLetterToUpperCase} from "../workTablePatients/PatientsList";
import {textLabels} from "../../consts/textLabels";

interface Props {
}

interface State {
    events: CalendarEvent[],
    filteredEvents: CalendarEvent[],
    rangeCount: number,
    doctorid: string,
    doctors: Doctor[],
    deptId?: string,
    depts: Dept[],
    doctorDisabled: boolean,
    currentDateRange: {start: Date, end: Date}
}

class Hospitalizations extends React.PureComponent<Props, State> {
    state: State = {
        events: [],
        filteredEvents: [],
        rangeCount: 0,
        doctorid: "",
        doctors: [],
        depts: [],
        doctorDisabled: false,
        currentDateRange: {start: new Date(), end: new Date()}
    }

    // Обработчик изменения диапазона дат
    changeDatesRangeHandler = (arg: { start: Date, end: Date }) => {
        const daysCount = Math.round(Math.abs((arg.start.getTime() - arg.end.getTime()) / (24 * 60 * 60 * 1000)));
        let dateStart = new Date(arg.start);
        let dateEnd = new Date(arg.end);

        if (daysCount === 42) {
            const middleDayMonth = new Date(dateStart);
            middleDayMonth.setDate(dateStart.getDate() + 8);
            dateStart.setFullYear(middleDayMonth.getFullYear(), middleDayMonth.getMonth(), 1);
            dateEnd.setFullYear(middleDayMonth.getFullYear(), middleDayMonth.getMonth() + 1, 1);
        }

        this.setState({
            currentDateRange: {start: dateStart, end: dateEnd},
            rangeCount: this.getFilteredEventsCount(dateStart, dateEnd)
        });
    }

    // Метод для подсчета событий в заданном диапазоне дат
    getFilteredEventsCount = (start: Date, end: Date): number => {
        return this.state.filteredEvents.filter((e: CalendarEvent) => {
            const eventDate = new Date(e.start);
            return end.getTime() > eventDate.getTime() && eventDate.getTime() > start.getTime();
        }).length;
    }

    getDoctorList = async (): Promise<void> => {
        const paginateOptions: PaginateOptions = {
            limit: 10000,
            page: 1,
            search: "",
            sort: "surname"
        };

        const responseDoctors: DoctorPaginationResponse = await agent.DoctorProvider.getList(paginateOptions);
        const responseDepts: DeptPaginationResponse = await agent.DeptProvider.getList(paginateOptions);

        if (responseDoctors && responseDepts) {
            this.setState({
                doctors: responseDoctors.docs,
                depts: responseDepts.docs
            });
        }
    };

    async componentDidMount() {
        await this.getDoctorList();

        let doctorid = await getDoctorId();
        if (doctorid)
            this.setState({doctorid: doctorid, doctorDisabled: true});

        await this.load();
    };

    async load() {
        const hospitalizations: PatientEventFull[] = await agent.PatientEventProvider.getHospitalizations(
            this.state.deptId, this.state.doctorid
        );

        let calendarEvents: CalendarEvent[] = [];
        if (hospitalizations) {
            hospitalizations.forEach((item: PatientEventFull) => {

                const eventArray = EventRepeater(item, `${item.patient.surname} ${item.patient.name && item.patient.name[0]}.${item.patient.middlename && item.patient.middlename[0]}.`,
                    `/dashboard/patients/${item.patient._id}/edit/patientInfo`);
                calendarEvents.push(...eventArray);
            });

            this.setState({
                events: calendarEvents,
                filteredEvents: calendarEvents
            }, () => {
                this.changeDatesRangeHandler(this.state.currentDateRange);
            });
        }
    }

    // Метод для обработки изменений фильтров
    handleFilterChange = async () => {
        await this.load();
    }

    render() {
        return (
            <div className={styles.componentWrapper}>
                <Header>{getGeneralTitle(GeneralTitleCase.hospitalizationstab)}</Header>
                <div style={{padding: "0px 332px 0 190px"}}>
                    <div style={{textAlign: "center"}}>Количество: {this.state.rangeCount}</div>
                </div>
                <div>
                    <Form>
                        <Form.Group>
                            <Form.Field width={"3"}>
                                <label>
                                    {firstLetterToUpperCase(getDoctorTitle(DoctorTitleCase.im))}
                                </label>
                                <Dropdown
                                    disabled={this.state.doctorDisabled}
                                    selection
                                    search={true}
                                    clearable={true}
                                    value={this.state.doctorid}
                                    onChange={(event: React.SyntheticEvent<HTMLElement>, data: DropdownProps) => {
                                        this.setState({
                                            doctorid: data.value != null ? data.value.toString() : ""
                                        }, this.handleFilterChange);
                                    }}
                                    options={this.state.doctors.map((doctor) => ({
                                        key: doctor._id,
                                        text: doctor.surname + " " + doctor.name + " " + doctor.middlename,
                                        value: doctor._id,
                                    } as DropdownItemProps))}
                                    noResultsMessage={textLabels.noResultsMessage}
                                />
                            </Form.Field>
                            <Form.Field width={"3"}>
                                <label>
                                    {firstLetterToUpperCase(getGeneralTitle(GeneralTitleCase.departmantim))}
                                </label>
                                <Dropdown
                                    disabled={this.state.doctorDisabled}
                                    selection
                                    search={true}
                                    clearable={true}
                                    value={this.state.deptId}
                                    onChange={(event: React.SyntheticEvent<HTMLElement>, data: DropdownProps) => {
                                        this.setState({
                                            deptId: (data.value && data.value !== "" ? data.value.toString() : undefined)
                                        }, this.handleFilterChange);
                                    }}
                                    options={this.state.depts.map((dept) => ({
                                        key: dept._id,
                                        text: dept.name,
                                        value: dept._id,
                                    } as DropdownItemProps))}
                                    noResultsMessage={textLabels.noResultsMessage}
                                />
                            </Form.Field>
                        </Form.Group>
                    </Form>
                </div>
                <MediaQuery minWidth={1224}>
                    <FullCalendar
                        plugins={[timeGridPlugin, dayGridPlugin, interactionPlugin, listPlugin]}
                        events={this.state.filteredEvents.map(event => {
                            const start = new Date(event.start);

                            if (start.getHours() === 23 && start.getMinutes() >= 1) {
                                return {
                                    ...event,
                                    end: new Date(start.getFullYear(), start.getMonth(), start.getDate(), 23, 59, 59).toISOString()
                                };
                            }
                            return event;
                        })}
                        initialView="dayGridMonth"
                        headerToolbar={{
                            left: 'prev,next today',
                            center: 'title',
                            right: 'dayGridMonth,timeGridWeek,timeGridDay,listWeek'
                        }}
                        views={{
                            listWeek: {
                                buttonText: 'Повестка недели',
                                displayEventTime: true
                            },
                            dayGridMonth: {
                                displayEventTime: true
                            },
                            timeGridWeek: {
                                displayEventTime: true
                            },
                            timeGridDay: {
                                displayEventTime: true
                            }
                        }}
                        eventTimeFormat={{
                            hour: '2-digit',
                            minute: '2-digit',
                            hour12: false
                        }}
                        locale={ruLocale}
                        nextDayThreshold='24:00:00'
                        displayEventTime={false}
                        datesSet={this.changeDatesRangeHandler}
                        eventDidMount={(arg) => {
                            arg.el.setAttribute("title", arg.event.title);
                        }}
                        eventClick={(event: EventClickArg) => {
                            if (event.event.url) {
                                event.jsEvent.preventDefault();
                                window.open(event.event.url, "_blank");
                            }
                        }}
                        slotMinTime="00:00:00"
                        slotMaxTime="24:00:00"
                        allDaySlot={false}
                        displayEventEnd={false}
                    />
                </MediaQuery>
                <MediaQuery maxWidth={1224}>
                    <FullCalendar
                        plugins={[timeGridPlugin, dayGridPlugin, interactionPlugin, listPlugin]}
                        events={this.state.filteredEvents.map(event => {
                            const start = new Date(event.start);

                            if (start.getHours() === 23 && start.getMinutes() >= 1) {
                                return {
                                    ...event,
                                    end: new Date(start.getFullYear(), start.getMonth(), start.getDate(), 23, 59, 59).toISOString()
                                };
                            }
                            return event;
                        })}
                        initialView="listMonth"
                        views={{
                            year: {
                                type: 'listYear',
                                buttonText: 'Повестка год',
                                displayEventTime: true
                            },
                            month: {
                                type: 'listMonth',
                                buttonText: 'Повестка месяц',
                                displayEventTime: true
                            }
                        }}
                        headerToolbar={{
                            left: 'prev,next today',
                            center: 'title',
                            right: 'month,year'
                        }}
                        locale={ruLocale}
                        nextDayThreshold='24:00:00'
                        eventTimeFormat={{
                            hour: '2-digit',
                            minute: '2-digit',
                            hour12: false
                        }}
                        displayEventTime={true}
                        displayEventEnd={false}
                        datesSet={this.changeDatesRangeHandler}
                        eventDidMount={(arg) => {
                            arg.el.setAttribute("title", arg.event.title);
                        }}
                        eventClick={(event: EventClickArg) => {
                            if (event.event.url) {
                                event.jsEvent.preventDefault();
                                window.open(event.event.url, "_blank");
                            }
                        }}
                    />
                </MediaQuery>
            </div>
        );
    }
}

export default Hospitalizations;